import { BsCameraVideoOffFill } from "react-icons/bs"; 
import { BsFillMicFill } from "react-icons/bs"; 
import { BsMicMuteFill } from "react-icons/bs"; 
import React, { useEffect, useState, useRef } from "react";
import Video from "twilio-video";
import Draggable from "react-draggable";
import { IconButton } from "@mui/material";
import CallImage from "../../assets/images/Authentek.jpg";
import { AccountCircleRounded, CloseSharp, Crop54, FlipCameraAndroid, Mic, MicOff, Phone, Remove, Videocam, VideocamOff } from "@mui/icons-material";
import { fetchUserRoledata } from "../../Redux/Api/fetch.api";
import { useSignalR } from '../SignalRContext/signalRContext';
import * as url from "../../api/uri_helper";

const TwilioVideocall = ({ onLeave, item, onClose, openedFromSupport = false }) => {
    const [room, setRoom] = useState(null);
    const localVideoRef = useRef(null);
    const latestTrack = useRef(null);
    const remoteVideoRef = useRef(null);
    const [isMinimized, setIsMinimized] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [isVideoEnabled, setIsVideoEnabled] = useState(true);
    const [remoteVideoDisabled, setRemoteVideoDisabled] = useState(false);
    const handleMinimize = () => setIsMinimized(true);
    const handleRestore = () => setIsMinimized(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const loggedUserId = localStorage.getItem('emailid');
    const [isCallInitiated, setIsCallInitiated] = useState(false);
    const [showCallTemplate, setShowCallTemplate] = useState(true);
    const [remoteUserId, setRemoteUserId] = useState(null);
    const UserId = localStorage.getItem('UserId');
    const [localTracks, setLocalTracks] = useState([]);
    const [remoteStreamAvailable, setRemoteStreamAvailable] = useState(false);
    // const remoteStreamAvailableRef = useRef(false);
    const [localStreamAvailable, setLocalStreamAvailable] = useState(true);
    const [remoteUserCameraAvialable, setRemoteUserCameraAvialable] = useState(true);
    // const [remoteMediaStatus, setRemoteMediaStatus] = useState({ audio: false, video: false })
    const [localMediaStatus, setLocalMediaStatus] = useState({ audio: false, video: false })

    // const loggedUserId = localStorage.getItem('UserId');
    const { setIsCallAccepted, roomId, roomdata, isCallAccepted,receiverId, setReceiverId, connection,setRoomData,initiateCall, callerFullName, connectionId, rejectCall, localStream, isInCall, setIsInCall, setLocalStream, togglevideoCallMedia, remoteMediaStatus, setRemoteMediaStatus, endCall } = useSignalR();

    useEffect(() => {
        if (isCallAccepted) {
            setShowCallTemplate(false);
            setLocalMediaStatus({audio: true, video: true})
        }
    }, [isCallAccepted]);
   
    useEffect(() => {
        if (openedFromSupport) {
            setShowCallTemplate(false);
        } else {
            setIsCallInitiated(true);
            setShowCallTemplate(false);
        }
    }, [openedFromSupport]);

    useEffect(() => {
        setReceiverId(item?.emailId);
    }, []);

    useEffect(() => {
        if (room) {
            setRoomData(room);
           // setRejectedCallId(remoteUserId);
        }
    }, [room]);

    useEffect(() => {
        const fetchDetails = async () => {
            if (!UserId) return;
            const response = await fetchUserRoledata(UserId);
            const userRoleDetails = response?.data?.data?.userRoleDetails || [];
            if (userRoleDetails[0]?.firstName || userRoleDetails[0]?.lastName) {
                setFirstName(userRoleDetails[0].firstName);
                setLastName(userRoleDetails[0].lastName)
            }
        };

        fetchDetails();
    }, []);

    useEffect(() => {
        if (remoteStreamAvailable && remoteVideoRef.current && latestTrack.current) {
          remoteVideoRef.current.appendChild(latestTrack.current.attach());
        }
      }, [remoteStreamAvailable]);

    useEffect(() => {
        if (remoteVideoRef.current && remoteVideoRef) {
          remoteVideoRef.current.srcObject = remoteVideoRef;
      
          const handleCanPlay = () => {
            setRemoteStreamAvailable(true);
          };
      
          remoteVideoRef.current.addEventListener("canplay", handleCanPlay);
      
          return () => {
            remoteVideoRef.current?.removeEventListener("canplay", handleCanPlay);
          };
        }
      }, [remoteVideoRef]);

    useEffect(() => {
        const roomname = roomId ? roomId : connectionId;
        let activeRoom = null;

        const joinRoom = async () => {
            try {
                //  First, Try to Join the Room
                const response = await fetch(
                    `${url.BASE}/TwilioTurn/token?identity=${loggedUserId}&roomName=${roomname}`
                );
                const data = await response.json();

                if (!data.token) {
                    console.error("Failed to get token");
                    return;
                }

                console.log("Token retrieved:", data.token);

                const checkCameraStatus = async () => {
                    try {
                      const devices = await navigator.mediaDevices.enumerateDevices();
                      const cameras = devices.filter(device => device.kind === 'videoinput');
                  
                      if (cameras.length === 0) {
                        console.warn("No camera detected.");
                        return false;
                      }
                  
                      const permissionStatus = await navigator.permissions.query({ name: 'camera' });
                  
                      if (permissionStatus.state === 'granted') {
                        return true;
                      }
                  
                      try {
                        await navigator.mediaDevices.getUserMedia({ video: true });
                        console.log("Camera access granted after prompt.");
                        return true;
                      } catch (error) {
                        if (error.name === "NotAllowedError") {
                          console.warn("Hey, camera access was blocked by the user.");
                        } else {
                          console.warn("Camera access denied or error occurred:", error);
                        }
                        return false;
                      }
                    } catch (error) {
                      console.error("Error checking camera access:", error);
                      return false;
                    }
                  };
                  
                console.log("Currrent call track : ", await checkCameraStatus() )
                  
                //set the room track between audio call and video call
                const cameraStatus = await checkCameraStatus();
                setLocalStreamAvailable(cameraStatus)
                const tracks = cameraStatus
                    ? await Video.createLocalTracks({ audio: true, video: true })
                    : [await Video.createLocalAudioTrack()];

                setLocalTracks(tracks);
                //  Connect to Twilio Room (Existing Room Will Be Used)
                activeRoom = await Video.connect(data.token, {
                    name: roomname,
                    tracks:tracks,
                });
                console.log('activeRoom : ', activeRoom)
                
                console.log("Successfully connected to room:", roomname);
                setRoom(activeRoom);

                //  Attach Local Video
                activeRoom.localParticipant.tracks.forEach((trackPublication) => {
                    if (trackPublication.track && localVideoRef.current) {
                        localVideoRef.current.appendChild(trackPublication.track.attach());
                    }
                });

                //  Handle Remote Participants
                const addRemoteParticipant = (participant) => {
                    console.log(`Participant "${participant.identity}" connected`);
                    setRemoteUserId(participant.identity);

                    participant.tracks.forEach((trackPublication) => {
                        if (trackPublication.isSubscribed && trackPublication.track) {
                            setIsCallAccepted(true);
                            remoteVideoRef.current?.appendChild(trackPublication.track.attach());
                        }
                    });

                    // participant.on("trackSubscribed", (track) => {
                    //     console.log(`New track subscribed: ${track.kind}`);
                    //     remoteVideoRef.current?.appendChild(track?.attach());
                    // });

                    participant.on("trackSubscribed", (track) => {
                        if (track.kind === "video") {
                            setRemoteStreamAvailable(true);
                          }                   
                        if (remoteVideoRef.current) {
                          remoteVideoRef.current.appendChild(track.attach());
                        }
                      });

                    participant.on("trackUnsubscribed", (track) => {
                        console.log(`Track unsubscribed: ${track.kind}`);
                        if (track.kind === "video") {
                            setRemoteStreamAvailable(true);
                          } 
                        else if (track.kind === "audio") {
                        }
                        track?.detach().forEach((el) => el.remove());
                    });
                    // Handle remote mute/unmute events
                    participant.tracks.forEach((publication) => {
                        if (publication.isSubscribed) {
                            handleTrackEvents(publication.track);
                        }
                        publication.on("subscribed", handleTrackEvents);
                    });
                };

                // Add existing participants
                activeRoom.participants.forEach(addRemoteParticipant);
                activeRoom.on("participantConnected", addRemoteParticipant);

                //  Handle Participant Disconnection
                activeRoom.on("participantDisconnected", (participant) => {
                    console.log(`Participant "${participant.identity}" disconnected`);
                    if (roomdata) {
                    console.log('roomdata of TVC', roomdata)
                    roomdata.localParticipant.tracks.forEach((trackPublication) => {
                        if (trackPublication.track) {
                            trackPublication.track.stop();
                            trackPublication.track.detach().forEach((el) => el.remove());
                        }
                    });
                    roomdata.disconnect();
                }
                });

            } catch (error) {
                console.error("Error joining room:", error);

                //  If Room Doesn't Exist, Create It Then Join
                if (error.message.includes("Room not found")) {
                    console.log("Room doesn't exist, creating a new one...");

                    const createRoomResponse = await fetch(
                        `${url.BASE}/TwilioTurn/create-room?roomName=${roomname}`,
                        { method: "POST" }
                    );

                    if (createRoomResponse.ok) {
                        console.log("Room created successfully, joining...");
                        joinRoom(); // Retry joining after room creation
                    } else {
                        console.error("Failed to create room.");
                    }
                }
            }
        };

        joinRoom();
        return () => {
            cleanupVideoResources(activeRoom);
        };

    }, [roomId]);

    // Get the status of camera and audio of the remote user
    useEffect(() => {
        if (!connection) return;
      
        const handleMediaToggle = (mediaData) => {
            console.log('mediaData : ', mediaData)
            if(mediaData){
                setRemoteMediaStatus(mediaData)
            }
        };
        connection.on('MediaToggle', handleMediaToggle);
      
        return () => {
          connection.off('MediaToggle', handleMediaToggle);
        };
      }, [connection]);

    const cleanupVideoResources = (activeRoom) => {
        if (activeRoom) {
            console.log("Disconnecting from room...");
            
            // Disconnect from the room first
            activeRoom.disconnect();
            
            // Clear the room state
            setRoom(null);
        }
        
        // Stop all local tracks regardless of room status
        localTracks.forEach(track => {
            track.stop();
            if (track.kind === 'video') {
                console.log("Stopping video track:", track);
            }
        });
        
        // Clear the local tracks array
        setLocalTracks([]);
        
        // Clear video elements
        if (localVideoRef.current) {
            localVideoRef.current.innerHTML = '';
        }
        
        if (remoteVideoRef.current) {
            remoteVideoRef.current.innerHTML = '';
        }
        
        // Call the onLeave callback if provided
        onLeave && onLeave();
    };

    function handleTrackEvents(track) {
        track.on("disabled", () => {
            if (track.kind === "video") setRemoteVideoDisabled(true);
        });
        track.on("enabled", () => {
            if (track.kind === "video") setRemoteVideoDisabled(false);
        });
    }

    const toggleMuteAudio = () => {
        if (!room) return;
      
        room.localParticipant.audioTracks.forEach((publication) => {
          if (isMuted) {
            publication.track.enable();
          } else {
            publication.track.disable();
          }
        });
        console.log('localMediaStatus : ', localMediaStatus)
        console.log('isMuted : ', isMuted)
        const updatedStatus = { ...localMediaStatus, audio: !localMediaStatus.audio };
        setLocalMediaStatus(updatedStatus);
        togglevideoCallMedia(updatedStatus);
      
        setIsMuted(!isMuted);
      };
      
    const toggleVideo = () => {        
        if (!room) return;
        room.localParticipant.videoTracks.forEach((publication) => {
          if (isVideoEnabled) {
            publication.track.disable();
          } else {
            publication.track.enable();
          }
        });
      
        const updatedStatus = { ...localMediaStatus, video: !isVideoEnabled };
        setLocalMediaStatus(updatedStatus);
        togglevideoCallMedia(updatedStatus);
      
        setIsVideoEnabled(!isVideoEnabled);
      };
      
      
    const rejectVideoCall = async () => {
        if (room) {
            console.log("Rejecting call, stopping media tracks...");
            cleanupVideoResources(room);
            // Notify the remote user
            if (remoteUserId) {
                connection.invoke("RejectCall", remoteUserId)
                    .catch((err) => console.error("Error rejecting call:", err));
            } else if (receiverId) {
                connection.invoke("RejectCall", receiverId);
            }
            setIsCallAccepted(false)
            setIsInCall(false)
            setLocalTracks([]);
            setIsCallAccepted(false);
            setRemoteMediaStatus({video: true , audio: true })
            setRemoteUserId(null)
            setReceiverId('')
            // rejectCall();
            onLeave && onLeave();
            onClose();
        }
    };
    
    // Ensure cleanup on component unmount
    useEffect(() => {
        return () => {
            if (room) {
                room.disconnect();
                setRoom(null);
            }
            navigator.mediaDevices.getUserMedia({ audio: true, video: true })
                .then((stream) => {
                    stream.getTracks().forEach((track) => track?.stop());
                })
                .catch((err) => console.error("Cleanup error:", err));
        };
    }, []);

    const handleInitiateCall = async () => {
        try {
            setShowCallTemplate(true);
            setIsCallInitiated(true);
            await initiateCall();
            setLocalMediaStatus({video: true, audio: true})
            togglevideoCallMedia({video: true, audio: true})
        } catch (error) {
            console.error('Failed to initiate call:', error);
        }
    };

    const getInitials = (name) => {
        if (!name) return "U";
        const words = name.split(" ");
        const initials = words.map(word => word.charAt(0).toUpperCase()).join("");
        return initials;
    };

    //Switching the camera between front and rear 
    const switchCamera = async () => {
        debugger;
        try {
            console.log("Switching camera...");
            
            // Find the current video track
            const videoTrack = localTracks.find(track => track.kind === 'video');
            
            if (!videoTrack) {
                console.error("No video track found to switch");
                return;
            }
            
            // Get current camera constraints
            const currentConstraints = videoTrack.getConstraints();
            const currentFacingMode = currentConstraints.facingMode;
            
            // Determine which camera to switch to
            const newFacingMode = currentFacingMode === 'user' ? 'environment' : 'user';
            console.log(`Switching from ${currentFacingMode} to ${newFacingMode}`);
            
            // Stop the current video track
            videoTrack.stop();
            
            // Create a new video track with the opposite camera
            const newVideoTrack = await Video.createLocalVideoTrack({
                video: {
                    facingMode: newFacingMode
                }
            });
            
            // Update local tracks state by replacing the old video track
            setLocalTracks(prevTracks => {
                const updatedTracks = prevTracks.map(track => 
                    track.kind === 'video' ? newVideoTrack : track
                );
                return updatedTracks;
            });
            
            // Replace the track in the room if we're connected
            if (room && room.localParticipant) {
                const trackPublications = Array.from(room.localParticipant.videoTracks.values());
                if (trackPublications.length > 0) {
                    const trackSid = trackPublications[0].trackSid;
                    await room.localParticipant.unpublishTrack(videoTrack);
                    await room.localParticipant.publishTrack(newVideoTrack);
                    
                    console.log("Successfully published new video track");
                }
            }
            
            // Update the video element in the DOM
            if (localVideoRef.current) {
                // Clear previous video elements
                localVideoRef.current.innerHTML = '';
                
                // Attach the new track
                localVideoRef.current.appendChild(newVideoTrack.attach());
            }
            
        } catch (error) {
            console.error("Error switching camera:", error);
        }
    };

    const handleUnLoad = () => {
        if(isInCall){
            console.log('isCallAccepted...................................................................................................', isCallAccepted)
            console.log('isInCall ...................................................................................................', isInCall)
            rejectVideoCall();
        }
    }
   window.addEventListener("beforeunload", handleUnLoad );

    return (
        <div className={`video-call-overlay ${isMinimized ? "minimized" : ""}`}>
            <Draggable cancel=".control-buttons, .controls, .local-video">
                <div className="video-call-modal">
                    {/* Header Controls */}
                    <div className="window-controls">
                        <div className="display-name">
                            <div className="videocall-header-avatar">
                                <div className="text-light chat-header-avatar">
                                    {getInitials((item?.requestedBy ?? callerFullName?.trim().split(" ")[1] + " " + callerFullName?.trim().split(" ")[0]) || item?.requestedBy)}
                                </div>
                            </div>
                            <span style={{ color: "black", fontSize: "21px" }}>
                                {item?.requestedBy ?? callerFullName?.trim().split(" ")[1] + " " + callerFullName?.trim().split(" ")[0]}
                            </span>
                        </div>
                        <div className="control-buttons">
                            <IconButton className="controlButtons" onClick={isMinimized ? handleRestore : handleMinimize}>
                                {isMinimized ? <Crop54 /> : <Remove />}
                            </IconButton>
                            <IconButton className="controlButtons" onClick={rejectVideoCall}>
                                <CloseSharp />
                            </IconButton>
                        </div>
                    </div>

                    {/* Video Call Container */}
                    <div className="video-call-container">
                        <div className="video-container">
                            {/* Local Video */}
                            <div className= "local-video">
                                <div className="d-flex justify-content-end position-absolute top-0 right-0 left-0 w-100">
                                    <h6 className="user-full-name">{`${firstName} ${lastName}`}</h6>
                                    <IconButton
                                        onClick={switchCamera}
                                        style={{ backgroundColor: "#FFFFFF59" }}
                                    >
                                        <FlipCameraAndroid style={{ color: "white" }} />
                                    </IconButton>
                                </div>
                                {!(localStreamAvailable && isVideoEnabled) && (
                                    <div className="position-absolute top-0 start-0 w-100 h-100 bg-secondary bg-opacity-75 border border-light rounded z-5 d-flex align-items-center justify-content-center twilio-local-container">
                                    <div className="twilio-local-avatar d-flex align-items-center justify-content-center text-white fw-bold">
                                        {lastName.trim().charAt(0) + firstName.trim().charAt(0)}
                                        </div>
                                    </div>
                                    
                                    )}
                                <div className="position-relative z-1" ref={localVideoRef} autoPlay />
                            </div>

                            {/* Call Template Animation */}
                            {(!isCallInitiated || showCallTemplate) ? (
                                <div className="calling-template">
                                    <div className="calling-animation">
                                        <div className="caller-image">
                                            <img src={CallImage} alt="Caller" />
                                        </div>
                                        {/* Only show ripple if the call is being initiated */}
                                        {showCallTemplate && <div className="ripple"></div>}
                                    </div>
                                    <h3 className="mt-5">
                                        {isCallInitiated
                                            ? `Calling ${item?.requestedBy ?? callerFullName?.trim().split(" ")[1] + " " + callerFullName?.trim().split(" ")[0]}...`
                                            : `Ready to call ${item?.requestedBy ?? callerFullName?.trim().split(" ")[1] + " " + callerFullName?.trim().split(" ")[0]}`}
                                    </h3>
                                </div>
                            ) : (
                                <>
                                    <div className="position-relative flex justify-content-center align-items-center h-100">
                                        <div ref={remoteVideoRef} autoPlay className="remote-video"/>
                                        {
                                            (!remoteStreamAvailable || !remoteMediaStatus.video) && (
                                                <div className={`twilio-avatar ${remoteUserCameraAvialable}`}>
                                                  <div className="twilio-avatar-circle">
                                                    {getInitials(
                                                      (item?.requestedBy ??
                                                        callerFullName?.trim().split(" ")[1] +
                                                          " " +
                                                          callerFullName?.trim().split(" ")[0]) || item?.requestedBy
                                                    )}
                                                  </div>
                                                </div>
                                              )
                                        }
                                        {
                                            <span className={'rounded-circle text-white d-flex align-items-center justify-content-center position-absolute twilio-video-remote-mic'}>
                                                {remoteMediaStatus?.audio ? <BsFillMicFill /> : <BsMicMuteFill />}
                                            </span>
                                        }
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Leave Call Button */}
                    <div className="controls">
                        <div className="d-flex gap-3 justify-content-center">
                            {(!openedFromSupport || isCallInitiated) && (
                                <>
                                    <IconButton
                                        disabled = {!localStreamAvailable}
                                        onClick={toggleVideo}
                                        style={{
                                            backgroundColor: isVideoEnabled ? "#FFFFFF59" : "#f44336",
                                        }}
                                    >
                                        {/* {isVideoEnabled ? (
                                            // <Videocam style={{ color: "white" }} />
                                            !localStreamAvailable ? ( <Videocam style={{ color: "white" }} /> ):<BsCameraVideoOffFill style={{ color: "white" }}/> ) : 
                                            ( <VideocamOff style={{ color: "white" }} /> )
                                        } */}
                                        {!localStreamAvailable ? (
                                            <VideocamOff style={{ color: "white" }} />
                                            ) : isVideoEnabled ? (
                                            <Videocam style={{ color: "white" }} />
                                            ) : (
                                            <BsCameraVideoOffFill style={{ color: "white" }} />
                                            )}

                                    </IconButton>
                                    <IconButton
                                        onClick={toggleMuteAudio}
                                        style={{
                                            backgroundColor: isMuted ? "#f44336" : "#FFFFFF59",
                                        }}
                                    >
                                        {isMuted ? (
                                            <MicOff style={{ color: "white" }} />
                                        ) : (
                                            <Mic style={{ color: "white" }} />
                                        )}
                                    </IconButton>
                                    <IconButton
                                        onClick={rejectVideoCall}
                                        style={{ backgroundColor: "#f44336" }}
                                    >
                                        <Phone style={{ color: "white" }} />
                                    </IconButton>
                                </>
                            )}
                            {/* Calling Button */}
                            {openedFromSupport && !isCallInitiated && (
                                <IconButton
                                    onClick={() => handleInitiateCall()}
                                    disabled= {!room}
                                    className = {room ? 'bg-success': 'bg-secondary'}
                                    style={{
                                        width: "201px",
                                        height: "67px",
                                        borderRadius: "12px"
                                    }}
                                >
                                    <Phone style={{ color: "white" }} />
                                </IconButton>
                            )}
                        </div>
                    </div>

                </div>
            </Draggable>
        </div>
    );
};

export default TwilioVideocall;
